import HistoryEntry from "@/models/Shared/HistoryEntry";
import GetHistoryResponse from "@/models/Shared/GetHistoryResponse";

export default class ListUtils {

    // Products General
    static cleanHistory(history: GetHistoryResponse): HistoryEntry[] {
        const historyArray = history.results;
        const cleanHistory: HistoryEntry[] = [];
        for (let index = 0; index < historyArray.length; index++) {
            const historyEntry = historyArray[index];
            if (historyEntry.changes){
                var filteredChanges = historyEntry.changes.filter(function(item) {
                    const pathsToIgnore = [ "$.updatedAtUtc, $.unPublishedChanges" ]
                    return pathsToIgnore.indexOf(item.path) == -1;
                })
                historyEntry.changes = filteredChanges;
                if (historyEntry.changes.length > 0) {
                    cleanHistory.push(historyEntry);
                }
            } else {
                //This must be a new entry
                cleanHistory.push(historyEntry);
            }
        }
        return cleanHistory;
    }

}